import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUserName'
})
export class FormatUserNamePipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      .split('.')
      .map(part =>
        part
          .toLowerCase()
          .replace(/^\w/, char => char.toUpperCase())
      )
      .join(' ');
  }
}